import React from 'react';

const Trading = () => {
  const buySteps = [
    {
      icon: '/select.svg',
      title: 'Select Ad',
      description: 'Browse verified merchant offers.'
    },
    {
      icon: '/place.svg',
      title: 'Place Order',
      description: 'Lock in your trade.'
    },
    {
      icon: '/pay.svg',
      title: 'Pay Seller',
      description: 'Complete payment via your preferred method.'
    },
    {
      icon: '/receive.svg',
      title: 'Receive Crypto',
      description: 'Crypto released from escrow to your wallet.'
    }
  ];

  const sellSteps = [
    {
      icon: '/select.svg',
      title: 'Post/Choose Ad',
      description: 'Create or select an offer.'
    },
    {
      icon: '/place.svg',
      title: 'Lock Crypto',
      description: 'Secure crypto in escrow.'
    },
    {
      icon: '/pay.svg',
      title: 'Receive Payment',
      description: 'Get paid in your local currency.'
    },
    {
      icon: '/receive.svg',
      title: 'Release Crypto',
      description: 'Confirm and release to buyer.'
    }
  ];

  return (
    <section
      className="py-12 sm:py-16 md:py-20 bg-gray-900 backdrop-blur-sm relative overflow-hidden"
      style={{
        background:
          "radial-gradient(51.47% 93.67% at 92.92% 27.08%, #384991 0%, #161837 72.6%)",
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Title */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white">
            P2P <span className="text-white">Trading Flow</span>
          </h2>
        </div>

        {/* Two Column Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 sm:gap-12 relative">
          {/* Divider Line */}
          <div className="hidden lg:block absolute left-1/2 top-0 bottom-0 w-px !bg-white transform -translate-x-1 "></div>

          {/* Left Column - Buy Crypto */}
          <div className="space-y-6 sm:space-y-8">
            <h3 className="text-2xl sm:text-3xl font-bold text-white mb-6 sm:mb-8">
              <span className="text-white">Buy</span> Crpto
            </h3>
            
            <div className="space-y-6 sm:space-y-8">
              {buySteps.map((step, index) => (
                <div key={index} className="flex items-start gap-4 sm:gap-6">
                  {/* Icon Circle */}
                  <div className="flex-shrink-0">
                  <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-full bg-[#161837] border border-[#2A356D] rounded-full flex items-center justify-center border-2 border-[#2A356D]">
                  <img
                        src={step.icon}
                        alt={step.title}
                        className="w-6 h-6 sm:w-8 sm:h-8 object-contain"
                      />
                    </div>
                  </div>

                  {/* Content */}
                  <div className="flex-1 pt-1">
                    <div className="text-white font-bold text-base sm:text-lg mb-1">
                      {index + 1}. {step.title}
                    </div>
                    <div className="text-white text-sm sm:text-base">
                      {step.description}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Column - Sell Crypto */}
          <div className="space-y-6 sm:space-y-8">
            <h3 className="text-2xl sm:text-3xl font-bold text-white mb-6 mt-4 sm:mb-8">
              <span className="text-white">Sell</span> Crpto
            </h3>
            
            <div className="space-y-6 sm:space-y-8">
              {sellSteps.map((step, index) => (
                <div key={index} className="flex items-start gap-4 sm:gap-6">
                  {/* Icon Circle */}
                  <div className="flex-shrink-0">
                    <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-full bg-[#161837] border border-[#2A356D] rounded-full flex items-center justify-center border-2 border-[#2A356D]">
                      <img
                        src={step.icon}
                        alt={step.title}
                        className="w-6 h-6 sm:w-8 sm:h-8 object-contain"
                      />
                    </div>
                  </div>

                  {/* Content */}
                  <div className="flex-1 pt-1">
                    <div className="text-white font-bold text-base sm:text-lg mb-1">
                      {index + 1}. {step.title}
                    </div>
                    <div className="text-white text-sm sm:text-base">
                      {step.description}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Trading;